import { useState } from 'react';
import { useGetPaymentSetupsQuery } from '../slices/paymentSetupsApiSlice';
const EMPTY = [];
export const usePaymentMethod = () => {
  const query = useGetPaymentSetupsQuery(undefined, { refetchOnMountOrArgChange: true });
  const [preferred, setPaymentMethod] = useState('');
  const methods = query.error || query.isFetching ? EMPTY : query.data?.methods || EMPTY;
  const paymentMethod = methods.some(m => m.value === preferred) ? preferred : methods[0]?.value || '';
  return { methods, paymentMethod, setPaymentMethod, loading: query.isFetching, error: query.error };
};
export default function PaymentMethodSelect({ methods, paymentMethod, setPaymentMethod, loading, error }) {
  return <label className="block text-sm">Payment method
    <select className="block w-full rounded border p-2" value={paymentMethod} disabled={loading || !methods.length} onChange={e => setPaymentMethod(e.target.value)}>
      {!methods.length && <option value="">{loading ? 'Loading payment methods...' : 'No payment method available'}</option>}
      {methods.map(m => <option key={m.value} value={m.value}>{m.label}</option>)}
    </select>
    {error && <span role="alert">Could not load payment methods. Refresh the page.</span>}
  </label>;
}
